import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/*! License details at fancyapps.com/license */
import { isPlainObject as s } from "./isPlainObject.js";
var _r = function r(t) {
  var n = arguments.length <= 1 ? 0 : arguments.length - 1;
  for (var c = 0; c < n; c++) {
    var _n = (c + 1 < 1 || arguments.length <= c + 1 ? undefined : arguments[c + 1]) || {};
    Object.entries(_n).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        e = _ref2[0],
        n = _ref2[1];
      var c = Array.isArray(n) ? [] : {};
      t[e] || Object.assign(t, _defineProperty({}, e, c)), s(n) ? Object.assign(t[e], _r(t[e], n)) : Array.isArray(n) ? Object.assign(t, _defineProperty({}, e, _toConsumableArray(n))) : Object.assign(t, _defineProperty({}, e, n));
    });
  }
  return t;
};
export { _r as extend };